import { render, staticRenderFns } from "./Historic.vue?vue&type=template&id=6cb0ca4a"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"
import style0 from "@/components/historic/styles/index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports